import React from 'react';
import PropTypes from 'prop-types';
import {find as _find, has as _has, isUndefined as _isUndefined} from 'lodash';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import {compose} from 'redux';
import {Header, Modal as SUIModal, Segment} from 'semantic-ui-react';

import {graphql, withApollo} from 'react-apollo';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {getLink} from '@appComponents/Link';
import {routes} from '@constants/routes';
import {PRODUCT_THIRD_PARTY} from '@constants/variables';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {GetThirdPartyClientPullOrigins, GetThirdPartyClientPullOrigin} from '@graphql/thirdPartyClientPullOrigin/query';

import ThirdPartyPullOriginsIndexButtons from '../components/ThirdPartyPullOriginsIndexButtons';
import ThirdPartyPullOriginsTable from '../components/ThirdPartyPullOriginsTable';
import ThirdPartyPullOriginsForm from '../forms/ThirdPartyPullOriginsForm';
import {exportExcel as thirdPartyPullOriginsIndexExportExcel} from '../utils/export/thirdPartyPullOriginsIndexExcel';


export class ThirdPartyPullOriginsIndex extends React.Component {
    static propTypes = {
        client: PropTypes.object,
        clientId: PropTypes.number.isRequired,
        DataThirdPartyPullOrigins: PropTypes.shape({
            loading: PropTypes.bool,
            thirdPartyClientPullOrigins: PropTypes.array,
        }),
        match: PropTypes.object.isRequired,
        Modal: PropTypes.object,
        prepareThirdPartyClientPullOriginsForStore: PropTypes.func.isRequired,
        thirdParty: PropTypes.number,
    };

    static defaultProps = {
        DataThirdPartyPullOrigins: {
            loading: false,
            thirdPartyClientPullOrigins: [],
        },
    };

    constructor() {
        super();

        this.state = {
            loadingModal: false,
            modalOpenedOnPageLoad: false,
            thirdPartyClientPullOrigins: [],
        };
    }

    componentDidUpdate(prevProps) {
        const {DataThirdPartyPullOrigins, match, Modal} = this.props;
        const {thirdPartyClientPullOrigins} = DataThirdPartyPullOrigins;

        if (thirdPartyClientPullOrigins
            && thirdPartyClientPullOrigins !== prevProps.DataThirdPartyPullOrigins.thirdPartyClientPullOrigins
        ) {
            this.setState({
                thirdPartyClientPullOrigins,
            }, () => {
                this.props.prepareThirdPartyClientPullOriginsForStore(thirdPartyClientPullOrigins);
            });
        }

        if (this.state.modalOpenedOnPageLoad) return;

        const prevPath = prevProps.match.path;
        const currentPath = match.path;
        const isCurrentlyLoading = DataThirdPartyPullOrigins.loading;
        const wasPreviouslyLoading = prevProps.DataThirdPartyPullOrigins.loading;

        const pullOriginRoutes = routes.clients.products.thirdParty.pullOrigins;

        if (
            currentPath === pullOriginRoutes.add.path
            && !isCurrentlyLoading
            && (prevPath !== currentPath || wasPreviouslyLoading)
        ) {
            this.prepareDataForModal({});
        }

        if (
            currentPath === pullOriginRoutes.edit.path
            && !isCurrentlyLoading
            && (prevPath !== currentPath || wasPreviouslyLoading)
        ) {
            const pullOrigin = thirdPartyClientPullOrigins.find((item) => convertToInt(item.id) === convertToInt(match.params.thirdPartyClientPullOriginId));

            if (!_isUndefined(pullOrigin)) {
                this.prepareDataForModal(pullOrigin);
            } else {
                Modal.setModal({
                    content: (
                        <div>
                            <Header icon='warning' color='red' content='Pull origin was not found' />
                            <SUIModal.Content>
                                <p>Pull origin was not found</p>
                            </SUIModal.Content>
                            <SUIModal.Actions>
                                <Link to={getLink('clients.products.thirdParty.pullOrigins.index', {
                                    id: match.params.id,
                                })}>
                                    Back to pull origins
                                </Link>
                            </SUIModal.Actions>
                        </div>
                    ),
                    isVisible: true,
                });
            }
        }
    }

    resetIndexUrl = () => {
        window.history.pushState({}, '', getLink('clients.products.thirdParty.pullOrigins.index', {
            id: this.props.clientId,
        }));
    };

    queryDataForModal = (id) => {
        const modalLink = getLink('clients.products.thirdParty.pullOrigins.edit', {
            id: this.props.clientId,
            thirdPartyClientPullOriginId: id,
        });

        this.setState(() => ({
            loadingModal: true,
        }));

        this.props.client.query({
            query: GetThirdPartyClientPullOrigin,
            variables: {
                id: id,
            },
        }).then((result) => {
            this.setState(() => ({
                loadingModal: false,
            }));

            this.openModal(result.data.thirdPartyClientPullOrigin, modalLink);
        });
    };

    prepareDataForModal = (id) => {
        this.setState(() => ({
            modalOpenedOnPageLoad: true,
        }));

        const modalLink = getLink('clients.products.thirdParty.pullOrigins.add', {
            id: this.props.clientId,
        });

        if (!isNaN(id)) {
            this.queryDataForModal(id);
        } else if (_has(id, 'id')) {
            this.queryDataForModal(id.id);
        } else {
            this.openModal({}, modalLink);
        }
    };

    openModal = (data, modalLink) => {
        const {
            Modal: {setModal},
        } = this.props;

        window.history.pushState({}, '', modalLink);

        setModal({
            content: <ThirdPartyPullOriginsForm
                clientProductThirdPartyId={this.props.thirdParty}
                formData={{
                    thirdPartyPullOrigin: data,
                }}
                resetIndexUrl={this.resetIndexUrl}
            />,
            loading: true,
            isVisible: true,
            onClose: this.resetIndexUrl,
        });
    };

    render() {
        return (
            <Segment basic loading={this.state.loadingModal} className='--marginTopNegative-15 --paddingTop-0'>
                <HeaderRenderer
                    buttons={ThirdPartyPullOriginsIndexButtons}
                    buttonsProps={{prepareDataForModal: this.prepareDataForModal}}
                    exportExcelParams={thirdPartyPullOriginsIndexExportExcel(
                        this.state.thirdPartyClientPullOrigins,
                        this.props.match.params.id
                    )}
                    loading={this.props.DataThirdPartyPullOrigins.loading}
                />
                <ThirdPartyPullOriginsTable
                    editClick={this.prepareDataForModal}
                    loading={this.props.DataThirdPartyPullOrigins.loading}
                    thirdPartyClientPullOrigins={this.state.thirdPartyClientPullOrigins}
                />
            </Segment>
        );
    }
}

const ThirdPartyPullOriginsWithGraphQL = compose(
    graphql(GetThirdPartyClientPullOrigins, {
        skip: props => (null === props.thirdParty),
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    clientProductThirdParty: props.thirdParty,
                },
            };
        },
        name: 'DataThirdPartyPullOrigins',
    })
)(ThirdPartyPullOriginsIndex);

const mapStateToProps = (state) => {
    let thirdPartyClientProduct = null;

    if (state.app.entities.client.clientProducts) {
        thirdPartyClientProduct = _find(state.app.entities.client.clientProducts, function (clientProduct) {
            return PRODUCT_THIRD_PARTY === convertToInt(clientProduct.product.id);
        });
    }

    return {
        client: state.app.entities.client,
        thirdParty: thirdPartyClientProduct
            ? convertToInt(thirdPartyClientProduct.third_party_client_product.id)
            : null,
    };
};
const mapDispatchToProps = mapModulesToProps(['Modal', 'MessageBox']);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withApollo(ThirdPartyPullOriginsWithGraphQL)));
